import { CleanerPageHeader } from "@/parts/CleanerPageHeader"
import { useTranslation } from "@/hooks/useTranslation"

export const ApprovalRequestPageHeader = ({
    children,
    onPrev
}: {
    children?: React.ReactNode
    onPrev?: () => void
}) => {
    const { t } = useTranslation()
    return (
        <CleanerPageHeader title={t("承認リクエスト")} onPrev={onPrev}>
            {children}
        </CleanerPageHeader>
    )
}
